import React, { useEffect } from 'react';
import './movements-wall-chart.scss';
import { useDispatch, useSelector } from "react-redux";
import { MediumLoadingSpinner } from "../../atoms/LoadingSpinner";
import { Center } from "../../atoms/StructuralLayout";
import MovementsList from "./components/team-movements-list/MovementsList";
import { BodyRegular } from "../../atoms/fonts/Body";
import { selectCalendarDate } from '@shared/store/dashboard.duck';
import { DATE_FORMAT } from '@shared/utils/DateUtils';
import { HeadlineSmall } from "../../atoms/fonts/Headline";
import styled from "styled-components";
import {
  loadLineReportsWhereabouts,
  selectIsLineReportOptionSelected,
  selectIsLoading,
  selectLineReportsWhereabouts
} from '@features/whereabouts/store/LineReportsWhereabouts.duck';
import { WhereaboutsGroupType } from '@features/whereabouts/models/movements.models';

interface TeamWallChartProps {
  enabledSetMovements: boolean;
  excludeCurrentUser?: boolean;
}

export function LineReportsWallChart(props: TeamWallChartProps) {
  const {enabledSetMovements, excludeCurrentUser} = props;
  const dispatch = useDispatch();
  const calendarDate = useSelector(selectCalendarDate);
  const dateString = calendarDate?.format(DATE_FORMAT);
  const whereabouts = useSelector(selectLineReportsWhereabouts);
  const isVisible = useSelector(selectIsLineReportOptionSelected);
  const loading = useSelector(selectIsLoading);

  useEffect(() => {
    if (isVisible) {
      dispatch(loadLineReportsWhereabouts({date: dateString}));
    }
  }, [dateString, isVisible, dispatch]);

  if (!isVisible) {
    return null;
  }

  return (
    <Container>
      {loading ?
        <>
          <Center style={{marginTop: 16}}>
            <MediumLoadingSpinner hideBorder={true} />
          </Center>
        </>
        :
        <>
          <HeadlineSmall>Your line reports</HeadlineSmall>
          {whereabouts?.length > 0 ?
            <MovementsList movements={whereabouts} enableSetMovements={enabledSetMovements} groupId={WhereaboutsGroupType.LineReport} excludeCurrentUser={excludeCurrentUser} /> :
            <BodyRegular>You have no line reports</BodyRegular>
          }
        </>
      }
    </Container>
  )
}

const Container = styled.div`
  margin-bottom: 24px;
`
